<template>
  <div>
    <b-navbar type="dark" variant="dark" class="mb-5" toggleable="lg" fixed="top">
      <b-navbar-brand
        >{{ $t("view-start.caption") }}
        {{ mode === "staging" ? "STAGING" : "" }}</b-navbar-brand
      >
      <b-navbar-toggle target="nav-collapse"> </b-navbar-toggle>

      <b-collapse id="nav-collapse" is-nav>
        <b-navbar-nav v-if="isLogedin">
          <b-nav-item to="/dashboard" :active="$route.name === 'dashboard'">{{
            $t("comp-menu.menu-home")
          }}</b-nav-item>
          <b-nav-item
            to="/shop"
            :active="$route.name === 'shop'"
            v-if="$loginData.hasRole('user')"
            >{{ $t("comp-menu.menu-shop") }}</b-nav-item
          >
          <b-nav-item
            to="/bought-products"
            :active="$route.name === 'boughtProducts'"
            v-if="$loginData.hasRole('user')"
            >{{ $t("comp-menu.menu-bought-products") }}</b-nav-item
          >
          <b-nav-item to="/projects" :active="$route.name === 'projects'">{{
            $t("comp-menu.menu-projects")
          }}</b-nav-item>
          <b-nav-item to="/downloads" :active="$route.name === 'downloads'">{{
            $t("comp-menu.menu-downloads")
          }}</b-nav-item>
          <b-nav-item
            to="/invoices"
            :active="$route.name === 'invoices'"
            v-if="
              $loginData.hasRole('user') &&
              !$selectedAccount.data.specs.hideInvoices
            "
            >{{ $t("comp-menu.menu-invoices") }}</b-nav-item
          >
          <b-nav-item
            to="/account"
            :active="$route.name === 'account'"
            v-if="$loginData.hasRole('user')"
            >{{ $t("comp-menu.menu-account") }}</b-nav-item
          >
          <b-nav-item-dropdown>
            <template #button-content>
              {{ $t("comp-menu.menu-me") }}
            </template>
            <b-dropdown-item to="/change-password">{{
              $t("comp-menu.menu-me-change-password")
            }}</b-dropdown-item>
            <b-dropdown-item to="/user">{{
              $t("comp-menu.menu-me-data")
            }}</b-dropdown-item>
          </b-nav-item-dropdown>
        </b-navbar-nav>

        <b-navbar-nav class="ml-auto">
          <!--<b-nav-item @click="toggleSidebar" v-if="isLogedin">
            <b-icon
              :icon="$events.sidebar.show ? 'envelope-open' : 'envelope'"
            ></b-icon>
            <b-badge v-if="this.$events.data.length">{{
              this.$events.data.length
            }}</b-badge>
          </b-nav-item>-->
          <b-nav-item @click="logout" v-if="isLogedin">{{
            $t("comp-menu.menu-logout")
          }}</b-nav-item>
          <comp-language-selector :nav="true" v-if="!hideLanguageSelector"/>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>
    <b-breadcrumb class="breadcrumb" v-if="isLogedin">
      <b-breadcrumb-item>
        {{ $loginData.data.firstname }} {{ $loginData.data.lastname }}
      </b-breadcrumb-item>
      <b-breadcrumb-item>
        {{ $loginData.data.id }}
      </b-breadcrumb-item>
      <b-breadcrumb-item
        >{{ $selectedAccount.data.companyName }} [{{
          $selectedAccount.data.id
        }}]</b-breadcrumb-item
      >
    </b-breadcrumb>
  </div>
</template>

<script>
import CompLanguageSelector from "../components/CompLangaugeSelector";
import { defaults } from "../assets/config";

export default {
  name: "CompMenu",
  components: {
    CompLanguageSelector,
  },
  data() {
    return {
      isLogedin: false,
      mode: defaults.mode,
      hideLanguageSelector: defaults.hideLanguageSelector

    };
  },
  methods: {
    logout() {
      this.isLogedin = false;
      this.$loginData.data = null;
      this.$router.push("/");
    },
    login() {
      console.log("to login...");
      this.$router.push("/login");
    },
    toggleSidebar() {
      this.$events.sidebar.show = !this.$events.sidebar.show;
    },
  },
  created() {
    this.$eventBus.$on("login", () => {
      this.isLogedin = typeof this.$loginData.data !== "undefined";
    });
    this.$eventBus.$on("logout", () => {
      this.logout();
    });
  },
};
</script>